import { Injectable } from "@angular/core";
import { BehaviorSubject, Subject, Subscription } from "rxjs";
import { SocketEvent, SocketEvents, SocketioService } from "./socketio.service";

@Injectable({
  providedIn: "root",
})
export class ConnectionService {
  private readonly messagesSubject = new BehaviorSubject<any>(null);
  messages = this.messagesSubject.asObservable();
  private connectionSubscription: Subscription;

  constructor(private socketService: SocketioService) {}

  connect(type: string = "doctor"): Subject<SocketEvent> {
    // Si ya hay una suscripción activa, cancelarla
    if (this.connectionSubscription) {
      this.connectionSubscription.unsubscribe();
    }

    // Crear nueva conexión y alimentar el BehaviorSubject
    const connection$ = this.socketService.connect(type);
    this.connectionSubscription = connection$.subscribe((event: SocketEvent) => {
      this.messagesSubject.next(event);
    });

    return connection$;
  }

  disconnect() {
    if (this.connectionSubscription) {
      this.connectionSubscription.unsubscribe();
    }
    this.socketService.disconnect();
  }

  getConnectionStatus() {
    return this.socketService.getConnectionStatus();
  }

  sendMsg(event: SocketEvents) {
    this.socketService.emit(event);
  }
}
